const openBlobNewWindow = blob => {
  window.open(URL.createObjectURL(blob), '_blank')
}

export { openBlobNewWindow }
